var _StyledToggle;
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useState } from 'react';
import List from '@mui/material/List';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import { styled, useTheme } from '@mui/material/styles';
import SovosTooltip from '../../../sovos-tooltip';
import SovosMenuItem from '../../../sovos-menu-item';
import { hasNestedLinks, isLinkSelected, navigationLinksPropTypes } from './navigationLinksUtils';
import SectionHeader from './SectionHeader';
import { collapsedWidthFactor } from '../../../themes/sovos-sizes';
import HEADER from '../../constants/header';
import { spacingToNumber } from '../../../internals/utils';
import BaseLink from './BaseLink';
import BaseSelectedIndicator from './BaseSelectedInidicator';
import BaseIcon from './BaseIcon';
import BaseToggle from './BaseToggle';
var StyledLink = styled(BaseLink)(function (_ref) {
  var spacing = _ref.theme.spacing;
  return {
    margin: "".concat(spacing(0.25), " ").concat(spacing(0.5), " 0 ").concat(spacing(0.5)),
    paddingLeft: spacing(0.25),
    paddingRight: spacing(0.25)
  };
});
var StyledSelectedIndicator = styled(BaseSelectedIndicator)(function (_ref2) {
  var spacing = _ref2.theme.spacing;
  return {
    left: spacing(0.5),
    marginRight: spacing(0.5),
    position: 'absolute',
    width: spacing(0.5)
  };
});
var StyledIcon = styled(BaseIcon)(function (_ref3) {
  var spacing = _ref3.theme.spacing;
  return {
    marginLeft: spacing(1.75)
  };
});
var StyledToggle = styled(BaseToggle)(function (_ref4) {
  var spacing = _ref4.theme.spacing;
  return {
    position: 'absolute',
    right: "-".concat(spacing(0.25))
  };
});
var nullLink = {
  anchorEl: null,
  link: null
};
var NavigationLinksMinimal = function NavigationLinksMinimal(_ref5) {
  var selectedLink = _ref5.selectedLink,
    onLinkClick = _ref5.onLinkClick,
    links = _ref5.links;
  var _useTheme = useTheme(),
    spacing = _useTheme.spacing;
  var _useState = useState(nullLink),
    _useState2 = _slicedToArray(_useState, 2),
    expandedMenu = _useState2[0],
    setExpandedMenu = _useState2[1];
  var closeMenu = function closeMenu() {
    return setExpandedMenu(nullLink);
  };
  var handleLinkClick = function handleLinkClick(event, link) {
    var expand = hasNestedLinks(link);
    if (expand) {
      setExpandedMenu({
        anchorEl: event.currentTarget,
        link: link.id || link.label
      });
    } else {
      onLinkClick(link, expand);
      closeMenu();
    }
  };
  var renderNestedLinkArrow = function renderNestedLinkArrow(link) {
    if (!hasNestedLinks(link)) return null;
    return _StyledToggle || (_StyledToggle = /*#__PURE__*/React.createElement(StyledToggle, null));
  };
  var renderNestedList = function renderNestedList(link) {
    var menuLeft = spacingToNumber(spacing(collapsedWidthFactor)) + spacingToNumber(spacing(0.5));
    if (hasNestedLinks(link)) {
      return /*#__PURE__*/React.createElement(Menu, {
        anchorEl: expandedMenu.anchorEl,
        anchorOrigin: {
          horizontal: menuLeft,
          vertical: 0
        },
        open: isLinkSelected(link, expandedMenu.link),
        onClose: closeMenu,
        transformOrigin: {
          horizontal: 'left',
          vertical: 'top'
        }
      }, link === null || link === void 0 ? void 0 : link.nestedLinks.map(function (nestedLink) {
        return /*#__PURE__*/React.createElement(SovosMenuItem, {
          disabled: link.disabled,
          onClick: link.disabled ? null : function (e) {
            return handleLinkClick(e, nestedLink);
          },
          key: nestedLink.label
        }, /*#__PURE__*/React.createElement(ListItemText, {
          primary: nestedLink.label
        }));
      }));
    }
    return null;
  };
  function shouldShowSelectedIndicator(link) {
    if (isLinkSelected(link, selectedLink)) {
      return true;
    }
    if (hasNestedLinks(link)) {
      return !!link.nestedLinks.find(function (nl) {
        return isLinkSelected(nl, selectedLink);
      });
    }
    return false;
  }
  function renderLinkItem(link) {
    var isSelected = shouldShowSelectedIndicator(link);
    if (link.type === HEADER) {
      return /*#__PURE__*/React.createElement(SectionHeader, {
        key: link.label
      });
    }
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: link.label
    }, /*#__PURE__*/React.createElement(SovosTooltip, {
      title: link.label
    }, /*#__PURE__*/React.createElement(StyledLink, {
      isDisabled: link.disabled,
      isSelected: isSelected,
      onClick: link.disabled ? null : function (e) {
        return handleLinkClick(e, link);
      }
    }, isSelected && /*#__PURE__*/React.createElement(StyledSelectedIndicator, {
      element: "i",
      isSelected: isSelected
    }), link.icon && /*#__PURE__*/React.createElement(StyledIcon, {
      element: link.icon
    }), renderNestedLinkArrow(link))), renderNestedList(link));
  }
  return /*#__PURE__*/React.createElement(List, {
    className: "sovosNavigationLinks"
  }, links.map(function (link) {
    return renderLinkItem(link);
  }));
};
NavigationLinksMinimal.propTypes = navigationLinksPropTypes;
export default NavigationLinksMinimal;